import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStatus, checkPersistedAuth } from '../store/hooks/useAuth';
import { URLS } from '.';
import { useEffect, useState } from 'react';

const PublicRoutes = () => {
    const isAuth = useAuthStatus();
    const [isChecked, setIsChecked] = useState(false);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    
    useEffect(() => {
        // Check both Redux state and direct localStorage check
        const persistedAuthState = checkPersistedAuth();
        
        if (isAuth || persistedAuthState) {
            setShouldRedirect(true);
        }
        
        setIsChecked(true);
    }, [isAuth]);
    
    console.log('~~~~~~~~~PUBLIC~~~~~~~~~~~~~~~~', isAuth, shouldRedirect);
    
    // Show nothing while checking to prevent flash of login screen
    if (!isChecked) {
        return null;
    }
    
    // If authenticated, redirect to crawler list
    if (shouldRedirect) {
        return <Navigate to={URLS.CRAWLER.LIST} replace />;
    }
    
    // Otherwise, render the children routes (login, etc.)
    return <Outlet />;
}

export default PublicRoutes;